import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const endpoint = "Event";
const json = { "Content-Type": "application/json" };
const url = (path: string) => `${environment.server.apiURL}/${endpoint}${path}`;

/** Non-matchday ticketed events. They sell through the same machinery as fixtures. */
export const EventService = {
	endpoint,
	status: async () => await FetchInterceptor(url("/Status"), {headers: json, method: "GET"}),
	getAll: async (seasonId?: number, upcomingOnly = false) => {
		const parts: string[] = [];
		if (seasonId) parts.push(`seasonId=${seasonId}`);
		if (upcomingOnly) parts.push("upcomingOnly=true");
		return await FetchInterceptor(url(parts.length ? `?${parts.join("&")}` : ""), {headers: json, method: "GET"});
	},
	add: async (data: any) => await FetchInterceptor(url(""), {body: JSON.stringify(data), headers: json, method: "POST"}),
	update: async (id: number, data: any) => await FetchInterceptor(url(`/${id}`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	remove: async (id: number) => await FetchInterceptor(url(`/${id}`), {headers: json, method: "DELETE"})
}
